/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';

/**
 *
 * @export
 * @interface ProjectModel
 */
export interface ProjectModel {
    /**
     *
     * @type {string}
     * @memberof ProjectModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof ProjectModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ProjectModel
     */
    content: string;
    /**
     *
     * @type {string}
     * @memberof ProjectModel
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof ProjectModel
     */
    author: string;
    /**
     *
     * @type {Date}
     * @memberof ProjectModel
     */
    publishOn: Date;
    /**
     *
     * @type {FileUrl}
     * @memberof ProjectModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ProjectModel interface.
 */
export function instanceOfProjectModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('content' in value)) return false;
    if (!('type' in value)) return false;
    if (!('author' in value)) return false;
    if (!('publishOn' in value)) return false;
    return true;
}

export function ProjectModelFromJSON(json: any): ProjectModel {
    return ProjectModelFromJSONTyped(json, false);
}

export function ProjectModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        content: json['content'],
        type: json['type'],
        author: json['author'],
        publishOn: new Date(json['publish_on']),
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ProjectModelToJSON(value?: ProjectModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        content: value['content'],
        type: value['type'],
        author: value['author'],
        publish_on: value['publishOn'].toISOString(),
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
